/**
 * Show basic data in rows
 */
angular.module('impactx.product').directive('ixBasicData', function () {
    return {
        scope: {
            label : '@',
            data : '@',
            link : '@',
            highlightSearchText: "="
        },
        restrict:'EA',
        templateUrl: 'modules/product/templates/basicdata.html'
    };
});